module.exports = __webpack_public_path__ + "static/media/icon-star.027671d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/icon-star.svg
// module id = 1255
// module chunks = 0